import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import CloudStatus from './Cloudstatus/CloudStatusListing';
import CloudStatusOT from './Cloudstatus/CloudStatusListingOT';

console.log(window.location.href);
var url = window.location.href;

if (url.includes("officetoolscloud"))
    ReactDOM.render(<CloudStatusOT />, document.getElementById('root'));
else if (url.includes("amicusattorney"))
    ReactDOM.render(<CloudStatus />, document.getElementById('root'));
else
    ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
